// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    INNOVATION_BY_DESIGN_FEATURED_FEED_LOADING() {
      return {
        isLoading: true,
        innovationByDesignFeaturedFeed: action.innovationByDesignFeaturedFeed
      };
    },
    INNOVATION_BY_DESIGN_FEATURED_FEED_LOADED() {
      return {
        isLoading: false,
        data: action.innovationByDesignFeaturedFeed
      };
    },
    INNOVATION_BY_DESIGN_FEATURED_FEED_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.innovationByDesignFeaturedFeed.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
